<script>
import * as moment from 'moment'
import LayerPersonChooser from '@/layer/components/LayerPersonChooser.vue';
import LayerBatchChooser from '@/layer/components/LayerBatchChooser.vue'

function createBuckets() {
  let buckets = [];
  for (let i = 1; i <= 60; i++) {
    buckets.push({
      number: i,
      weightKg: 0,
      batchName: '',
      unconsumed: false,
    });
  }
  return buckets;
}

export default {
  components: {
    LayerPersonChooser,
    LayerBatchChooser,
  },

  data: () => ({
    //deductWeightGrams: 670, // Subtract the weight of the bucket so they do not have to weight them separately
    deductWeightGrams: 0,

    date: moment().format('YYYY-MM-DD'),
    person: '',
    buckets: createBuckets(),
  }),

  computed: {
    validationError() {
      if (!this.date) return 'Please choose a Placed Date'
      if (!this.person) return 'Please choose a Person'

      if (!this.buckets.find(x => x.weightKg && this.calcDeductedBucketWeight(Number(x.weightKg)) > 0)) {
        //return `At least one bucket weight must be more than 0. Remember we automatically deduct ${this.deductWeightGrams} grams (${Number(this.deductWeightGrams / 1000).toFixed(2)} kg)`;
        return `At least one bucket weight must be more than 0`;
      }

      const bucketsWithMissingBatches = this.buckets.filter(x => this.calcDeductedBucketWeight(Number(x.weightKg)) > 0 && !x.batchName)
      if (bucketsWithMissingBatches.length > 0) {
        return `Please select a Batch for buckets ${bucketsWithMissingBatches.map(b => String(b.number)).join(', ')}`
      }

      return undefined;
    },

    foodPerBatchMap() {
      const foodPerBatchMap = {}
      this.buckets
        .filter(x => x.weightKg > 0)
        .forEach(x => {
          foodPerBatchMap[x.batchName] = (foodPerBatchMap[x.batchName] || 0) + (x.weightKg > 0 ? this.calcDeductedBucketWeight(x.weightKg) : 0)
        })
      return foodPerBatchMap
    },

    submitPayload() {
      return {
        date: this.date,
        person: this.person,
        food_per_batch: this.foodPerBatchMap,
      }
    },
  },

  methods: {
    calcDeductedBucketWeight(weightKg) { return weightKg - (this.deductWeightGrams / 1000.0) },
    calcAddBucketWeight(weightKg) { return weightKg + (this.deductWeightGrams / 1000.0) },

    clearForm() {
      this.date = moment().format('YYYY-MM-DD')
      this.person = ''
      this.buckets = createBuckets();
    },

    onFormSubmitSuccess(newRecord) {
      this.clearForm();
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>

  <b-card>
    <api-form
      method="put"
      url="v1/layers/food-buckets-record"
      :payload="submitPayload"
      submit-text="Add"
      :validation-error="validationError"
      :make-success-message="() => `Buckets record was successfully added.`"
      @success="onFormSubmitSuccess"
      @cancel="onCancelledForm">

      <slot name="above-header"></slot>

      <h4 class="text-center mt-0">Add Buckets</h4>

      <b-form-group label="Date" :label-for="`date-${_uid}`">
        <b-form-input :id="`date-${_uid}`" v-model="date" type="date" placeholder="Date..." required></b-form-input>
      </b-form-group>

      <layer-person-chooser v-model="person" required />

      <div v-show="person">
        <label class="font-weight-bold">Bucket Weights</label>

        <b-alert v-if="deductWeightGrams > 0" variant="info" show>
          <i class="fa fa-info-circle"></i>
          <span>Bucket weight of <strong>{{deductWeightGrams}}g</strong> will automatically be deducted when added.</span>
        </b-alert>

        <div v-for="bucket in buckets" :key="bucket.number" class="row">
          <div class="col-6">
            <b-input-group class="mb-1" size="sm">
              <b-input-group-text slot="prepend">
                <div style="width:30px"> {{bucket.number}} </div>
              </b-input-group-text>

              <b-form-input
                :id="`buckets-${_uid}`"
                v-model="bucket.weightKg"
                type="number"
                step="any"
                placeholder="Bucket weight..."
                required
                style="height:33px"
                @focus="$event.target.select()"></b-form-input>

              <b-input-group-text slot="append"> kg </b-input-group-text>

            </b-input-group>
          </div>

          <div class="col-6">
            <layer-batch-chooser
              v-if="bucket.weightKg > 0"
              v-model="bucket.batchName"
              mode="chicken_weight"
              label=""
              form-group-class="mb-0"
              select-batch-text="Batch..." />
          </div>
        </div>

        <div class="mt-5"></div>

        <b-alert v-if="deductWeightGrams > 0" variant="info" show>
          <i class="fa fa-info-circle"></i>
          <span>Bucket weight of <strong>{{deductWeightGrams}}g</strong> will automatically be deducted when added.</span>
        </b-alert>

        <div v-if="!validationError">
          <b-badge
            v-for="(weight,batchName) in foodPerBatchMap"
            :key="batchName"
            variant="secondary"
            class="mr-2">
            {{batchName}}: {{weight | roundNumber(3)}} kg
          </b-badge>

          <div class="mt-5"></div>
        </div>

      </div>

    </api-form>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/layer/components/AddBucketsRecord.vue